import { Button, FormControlLabel, Popover, Toolbar } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CustomLink from "components/CustomLink";
import CustomTable from "components/CustomTable";
import EditFormControl from "components/form/EditFormControl";
import SearchComponent, { searchDataFc } from "components/SearchComponent";
import { CustomStatusBadge } from "components/StatusBadge";
import CustomText from "components/typography/CustomText";
import { removeItemArray } from "lib/arrayObject";
import { orderStatusOptions, paymentStatusOption, postcodes } from "lib/global";
import { serverGet } from "lib/serverRequest";
import { isEmpty } from "lodash";
import { addressDetailInfo } from "models/third/addressRight";
import { sendCustomEmail, updateSelectedSlots } from "models/weeklySlotsModel";
import moment from "moment-timezone";
import { useSnackbar } from "notistack";
import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { openLoading } from "store/reducers/tools";
import { ResendDialog } from "./ResendDialog";
import { getCurrentWeekNum } from "lib/date";
import { getWeekDateByWeekNumber } from "lib/date";

export function EnhancedTableToolbar({
  type = "",
  count = 0,
  selPie = {},
  pies = [],
  selected = 0,
  moveDate = null,
  reason = "",
  searchWord = "",
  searchType = "",
  anchorEl = null,
  sendEmail = true,
  onClickResend = () => {},
  onChangeEmailSend = () => {},
  onChangeReason = () => {},
  onChangeSearchType = () => {},
  onSetAnchor = () => {},
  onChange = () => {},
  onChangePie = () => {},
  onChangeDate = () => {},
  onMoveSelected = () => {},
  onClickEmail = () => {},
}) {
  const [blackoutDates, setBlackoutDates] = useState([]);
  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  const calcMindate = () => {
    // let date = new Date();
    // if (Boolean(data?.payment_intent?.id)) {
    //   return date.setDate(date.getDate() + 2);
    // } else {
    const currentWeek = getCurrentWeekNum();
    return getWeekDateByWeekNumber(currentWeek + 2, 0);
    // }
  };

  useEffect(() => {
    serverGet({
      url: "blackout-day",
      onFinish: (res, err) => {
        if (res === false) {
          return;
        }
        setBlackoutDates((s = []) =>
          res.map((item) => new Date(item.blackout_day))
        );
      },
    });
    //eslint-disable-next-line
  }, []);
  return (
    <Toolbar
      className="p-2 border-b border-white-gray"
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <div className="flex justify-between items-center w-full">
        <div className="flex items-center">
          <CustomText variant="body" bold={600}>
            {`All Orders (${count})`}
          </CustomText>
          <FormControlLabel
            control={
              <EditFormControl
                value={selPie}
                type="select"
                size="small"
                options={[{ name: "All Flavors", id: "all" }, ...pies]}
                optionLabel={(option) => option.name}
                onChange={onChangePie}
                fullWidth
                className="w-64 mr-7"
              />
            }
            label={
              <CustomText variant="body" className="mr-2">
                Orders containing
              </CustomText>
            }
            labelPlacement="start"
          />
          <SearchComponent
            searchWord={searchWord}
            searchType={searchType}
            placeholder="Search Orders"
            onChange={onChangeSearchType}
            onKeyDown={(e) => onChange(e)}
            onBlur={onChange}
          />
        </div>
        <div className="">
          <Button
            className="border-white-gray my-0.5 mx-1"
            variant="outlined"
            onClick={onClickResend}
          >
            <CustomText
              className="text-black uppercase"
              variant="body"
              bold={600}
            >
              Re-Send
            </CustomText>
          </Button>
          <Button
            className="border-white-gray my-0.5 mx-1"
            variant="outlined"
            onClick={onClickEmail}
          >
            <CustomText
              className="text-black uppercase"
              variant="body"
              bold={600}
            >
              Email
            </CustomText>
          </Button>
          <Button
            className="border-white-gray my-0.5 mx-1"
            variant="outlined"
            onClick={(e) => {
              if (!Boolean(selected)) return;
              onSetAnchor(e.currentTarget);
            }}
          >
            <CustomText className="text-black" variant="body" bold={600}>
              MOVE SELECTED
            </CustomText>
          </Button>
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => onSetAnchor(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <CustomText
              className="border-b border-white-gray text-secondary p-4"
              bold
            >
              {`MOVE SELECTED (${selected})`}
            </CustomText>
            <CustomText className="text-secondary pt-3 pb-1 px-4">
              {type === "dispatch-date" ? "DISPATCH DATE" : "BAKE DATE"}
            </CustomText>
            <div className="px-4 flex flex-1">
              <DatePicker
                className="px-3 py-1 border rounded border-white-gray"
                withPortal
                dateFormat="dd/MM/yyyy"
                excludeDates={blackoutDates}
                minDate={calcMindate()}
                selected={moveDate}
                filterDate={isWeekday}
                onChange={onChangeDate}
              />
            </div>
            <div className="px-4 py-2">
              <EditFormControl
                value={reason}
                type="multiline"
                size="small"
                rows={3}
                onChange={onChangeReason}
                fullWidth
              />
            </div>
            <div className="flex items-center px-4 py-2">
              <EditFormControl
                type="checkbox"
                value={sendEmail}
                label="Send Customer Email"
                onChange={onChangeEmailSend}
              />
            </div>
            <Button
              className="px-4 mt-4 mb-7 mx-4"
              color="secondary"
              variant="contained"
              onClick={onMoveSelected}
            >
              MOVE SELECTED
            </Button>
          </Popover>
        </div>
      </div>
    </Toolbar>
  );
}

export default function WeeklySlotsOrderTable({
  pies = [],
  data: props_data = [],
  count = 0,
  type = "",
  selWeekNum = 1,
  onChange = () => {},
  onView = () => {},
  onCloseSummary = () => {},
  onRefresh = () => {},
  onSelected = () => {},
  onReSchedule = () => {},
  ...props
}) {
  const { enqueueSnackbar } = useSnackbar();
  // const history = useHistory();
  // const [slotData, setSlotData] = useState([]);
  const [searchWord, setSearchWord] = useState("");
  const [data, setData] = useState([]);
  const [selPie, setSelPie] = useState({ name: "All Flavours", id: "all" });
  const [checkAll, setCheckAll] = useState();
  const [selected, setSelected] = useState([]);
  const [moveDate, setMoveDate] = useState(null);
  const [reason, setReason] = useState("");
  const [resend, setResend] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);
  const [sendEmail, setSendEmail] = useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchType, setSearchType] = useState("all");
  const [emailData, setEmailData] = useState({});
  const authUser = useSelector((state) => state?.auth?.user ?? {});

  const searchData = useMemo(() => {
    let filteredData = data;
    if (searchWord) {
      filteredData = filteredData.filter((row) => {
        return searchDataFc({ row, searchType, searchWord });
      });
    }
    if (!isEmpty(selPie)) {
      filteredData =
        selPie?.id === "all"
          ? filteredData
          : filteredData.filter((row) =>
              row?.pies?.some((pie) => pie.id === selPie.id)
            );
    }
    return filteredData;
    //eslint-disable-next-line
  }, [data, searchWord, searchType, selPie]);

  const handleSearchWord = (e) => {
    setSearchWord(e.target.value.trim().replace(/[^A-Za-z0-9@. ]/g, ""));
  };

  const handleSelectAll = (e) => {
    const { value = false } = e.target;
    setCheckAll(value);
    setSelected((prev) =>
      Boolean(value) ? searchData?.map((item) => item?.id) : []
    );
    onSelected(Boolean(value) ? searchData : []);
  };

  const handleChangeCheckbox = (e, row) => {
    const { value = false } = e.target;
    let newSelected = selected;
    if (Boolean(value)) {
      newSelected = [...newSelected, row?.id];
    } else {
      const findIndex = newSelected.findIndex((item) => item === row.id);
      newSelected =
        findIndex >= 0 ? removeItemArray(newSelected, findIndex) : newSelected;
    }
    setSelected((s = []) => newSelected);
    onSelected(
      newSelected.map((cur) => searchData.find((item) => item.id === cur))
    );
    setCheckAll((s = false) =>
      Boolean(newSelected.length === searchData?.length)
    );
  };

  const handleMoveSelected = async () => {
    if (!Boolean(moveDate)) {
      enqueueSnackbar("Please select the date!", { variant: "warning" });
      return;
    }
    let week_day = moveDate.getDay();
    let week_num = moment(moveDate).isoWeek();
    let week_year = moment(moveDate).isoWeekYear();
    if (type === "bake-date") {
      if (week_day === 5) {
        week_day = 1;
        week_num = week_num + 1;
      } else week_day = week_day + 1;
    } else {
      //checking move data address in the invergall
      if (week_day === 5) {
        const moveData = selected.map((key) =>
          searchData.find((item) => item.id === key)
        );
        let addressFlags = [];
        await Promise.all(
          moveData.map(async (item) => {
            const addressDetails = await addressDetailInfo(item.address?.id);
            addressFlags.push(
              postcodes.some(
                (postcode) =>
                  postcode === addressDetails?.structured_address?.postcode
              )
            );
          })
        );
        if (addressFlags.includes(false)) {
          enqueueSnackbar("Please check the invercargill address!", {
            variant: "warning",
          });
          return;
        }
      }
    }
    openLoading(true);
    updateSelectedSlots({
      data: {
        selected: selected,
        week_day: week_day,
        week_num: week_num,
        week_year: week_year,
        move_reason: reason,
        send_move_email: sendEmail,
        authUser,
      },
      onFinish: (res, err) => {
        openLoading(false);
        onCloseSummary();
        onRefresh();
        setAnchorEl(null);
        setCheckAll(false);
        setSelected([]);
        setReason("");
        setMoveDate(null);
      },
    });
  };

  const handleSendEmail = () => {
    if (!Boolean(emailData?.title) || !Boolean(emailData?.content)) {
      enqueueSnackbar("Please write the title and content!", {
        variant: "warning",
      });
      return;
    }
    openLoading(true);
    sendCustomEmail({
      data: {
        selected,
        emailData,
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          enqueueSnackbar("Please try again!", {
            variant: "warning",
          });
          return;
        }
        setEmailData({});
        setEmailOpen(false);
      },
    });
  };

  const handleClickResend = () => {
    if (selected?.length === 0) {
      enqueueSnackbar("Please select the orders!", { variant: "warning" });
      return;
    }
    setResend(true);
  };

  const handleClickEmailBtn = () => {
    if (selected?.length === 0) {
      enqueueSnackbar("Please select the orders!", { variant: "warning" });
      return;
    }
    setEmailOpen(true);
  };

  const handleFinishReSend = (updateData) => {
    onReSchedule(updateData);
    setResend(false);
    setSelected([]);
    enqueueSnackbar("Successfully re-sent!", { variant: "success" });
  };

  useEffect(() => {
    setData(props_data);
  }, [props_data]);

  return (
    <div>
      <CustomTable
        data={searchData}
        size="normal"
        checkAll={checkAll}
        pageCount={10}
        columns={[
          {
            label: "",
            sortable: "no",
            selector: "checkbox",
            cell: (row) => (
              <EditFormControl
                type="checkbox"
                isLabel={false}
                value={selected?.some((item) => item === row.id)}
                onChange={(e) => handleChangeCheckbox(e, row)}
              />
            ),
          },
          {
            label: "Order ID",
            selector: "id",
            cell: (row) => (
              <CustomLink
                className="text-primary"
                to={`order/${row.id}`}
                // onClick={() => history.push(`order/${row.id}`)}
              >
                #{row?.id}
              </CustomLink>
            ),
          },
          {
            label: "Order Type",
            selector: "box_type",
            cell: (row) => (row.box_type ? "Sub" : "One Off"),
          },
          {
            label: "Name",
            selector: "name",
          },
          {
            label: "Address",
            selector: "address",
            sortValue: (row) =>
              (row?.order_address ?? row?.address)?.label ?? "",
            cell: (row) => (
              <span>{(row?.order_address ?? row?.address)?.label ?? ""}</span>
            ),
          },
          {
            label: "Region",
            selector: "region",
            sortValue: (row) =>
              row?.region ?? (row?.order_address ?? row?.address)?.region ?? "",
            cell: (row) =>
              row?.region ?? (row?.order_address ?? row?.address)?.region ?? "",
          },
          {
            label: "PostCode",
            selector: "postcode",
            sortValue: (row) =>
              (row?.order_address ?? row?.address)?.postcode ?? "",
            cell: (row) => (row?.order_address ?? row?.address)?.postcode ?? "",
          },
          { label: "Email", selector: "email" },
          {
            label: "Payment",
            sortable: "no",
            selector: "paymentStatus",
            cell: (row) => (
              <CustomStatusBadge
                size="body2"
                text={
                  paymentStatusOption.find(
                    (item) => item.id === (row?.paid ?? "0")
                  )?.label
                }
                variant={
                  paymentStatusOption.find(
                    (item) => item.id === (row?.paid ?? "0")
                  )?.variant
                }
              />
            ),
          },
          {
            label: "Status",
            sortable: "no",
            selector: "status",
            cell: (row) => (
              <CustomStatusBadge
                size="body2"
                text={
                  orderStatusOptions.find(
                    (item) =>
                      item.id ===
                      (row?.tracking_info?.consignmentId
                        ? "1"
                        : row?.status ?? "0")
                  )?.label
                }
                variant={
                  orderStatusOptions.find(
                    (item) =>
                      item.id ===
                      (row?.tracking_info?.consignmentId
                        ? "1"
                        : row?.status ?? "0")
                  )?.variant
                }
              />
            ),
          },
        ]}
        toolbar={
          <EnhancedTableToolbar
            pies={pies}
            type={type}
            searchType={searchType}
            anchorEl={anchorEl}
            count={count}
            searchWord={searchWord}
            selPie={selPie}
            reason={reason}
            selected={selected?.length}
            moveDate={moveDate}
            sendEmail={sendEmail}
            onClickResend={handleClickResend}
            onClickEmail={handleClickEmailBtn}
            onChangeEmailSend={(e) => setSendEmail(e.target.value)}
            onChangeReason={(e) => setReason(e.target.value)}
            onChangeSearchType={(e) => setSearchType(e.target.value)}
            onChangeDate={(d) => setMoveDate(d)}
            onChangePie={(e) => setSelPie(e.target.value)}
            onChange={handleSearchWord}
            onMoveSelected={handleMoveSelected}
            onSetAnchor={(v) => setAnchorEl(v)}
          />
        }
        onSelectAll={handleSelectAll}
      />
      <CustomDialog
        title="Send Customer Email"
        open={emailOpen}
        isAction={true}
        onClose={() => setEmailOpen(false)}
      >
        <div>
          <CustomText color="secondary" variant="body">
            Subject
          </CustomText>
          <EditFormControl
            type="multiline"
            fullWidth
            rows={1}
            name="title"
            value={emailData?.title ?? ""}
            onChange={(e) =>
              setEmailData((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }))
            }
          />
        </div>
        <div className="my-2">
          <CustomText color="secondary" variant="body">
            Body
          </CustomText>
          <EditFormControl
            type="ckeditor"
            fullWidth
            name="content"
            value={emailData?.content ?? ""}
            onChange={(e) =>
              setEmailData((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }))
            }
          />
        </div>
        <div className="flex justify-end items-center">
          <Button
            className="mx-2 px-4  font-bold font-zing text-base"
            variant="outlined"
            color="primary"
            onClick={handleSendEmail}
          >
            Send
          </Button>
          <Button
            className="mx-2 px-4 font-bold font-zing text-base"
            variant="outlined"
            color="secondary"
            onClick={() => setEmailOpen(false)}
          >
            Close
          </Button>
        </div>
      </CustomDialog>
      <ResendDialog
        open={resend}
        selected={selected}
        onFinishReSchedule={handleFinishReSend}
        onClose={() => setResend(false)}
      />
    </div>
  );
}
